
import { useState } from "react";
import SignInForm from "@/components/auth/SignInForm";
import SignUpForm from "@/components/auth/SignUpForm";
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import { RecaptchaProvider } from "@/components/RecaptchaProvider";

type AuthMode = "signin" | "signup" | "forgot-password";

const Auth = () => {
  const [authMode, setAuthMode] = useState<AuthMode>("signin");

  const handleToggleForm = () => {
    setAuthMode(authMode === "signin" ? "signup" : "signin");
  };

  const handleForgotPassword = () => {
    setAuthMode("forgot-password");
  };

  const handleBackToSignIn = () => {
    setAuthMode("signin");
  };

  const handleSuccessfulSignUp = () => {
    setAuthMode("signin");
  };

  return (
    <RecaptchaProvider>
      <div className="min-h-screen bg-black text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-md mx-auto bg-gray-900 rounded-lg p-8 border border-gray-800">
          {authMode === "signin" && (
            <SignInForm 
              onToggleForm={handleToggleForm} 
              onForgotPassword={handleForgotPassword}
            />
          )}
          {authMode === "signup" && (
            <SignUpForm 
              onToggleForm={handleToggleForm} 
              onSuccessfulSignUp={handleSuccessfulSignUp} 
            />
          )}
          {authMode === "forgot-password" && (
            <ForgotPasswordForm onBackToSignIn={handleBackToSignIn} />
          )}
          </div>
        </div>
      </div>
    </RecaptchaProvider>
  );
};

export default Auth;
